import { memo, useCallback } from 'react';
import { Button } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';

import { ROW_STATUS } from '../../../constants/reviewFilters.js';

/**
 * Last cell of a review row: Fix on an error row, Edit otherwise. Opens the Fix dialog.
 *
 * @param {object} props
 * @param {{ status: string }} props.row
 * @param {(row: object) => void} props.onEdit
 */
function EditRowButton({ row, onEdit }) {
  const { t } = useTranslation('people-access');
  const handleClick = useCallback(() => onEdit(row), [onEdit, row]);
  return (
    <Button variant="ghost" size="sm" onClick={handleClick}>
      {row.status === ROW_STATUS.ERROR ? t('import.review.actions.fix') : t('import.review.actions.edit')}
    </Button>
  );
}

export default memo(EditRowButton);
